import type { AnyFieldApi } from '@tanstack/react-form';
import type { ChangeEventHandler } from 'react';

import { useCallback, useMemo } from 'react';

import Checkbox from '../../../../components/Checkbox/Checkbox';

interface RuleCheckboxProps {
  /**
   * Field rule checkbox field
   */
  field: AnyFieldApi;
  /**
   * Content type property name
   */
  propertyKey: string;
  /**
   * If field is disabled
   */
  disabled?: boolean;
  /**
   * Component test ID
   */
  testId?: string;
}

const RuleCheckbox = ({
  field,
  propertyKey,
  disabled,
  testId,
}: RuleCheckboxProps) => {
  const fieldIndex = useMemo(
    () => field.state.value?.findIndex((key: string) => key === propertyKey),
    [field.state.value, propertyKey],
  );

  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
    (e) => {
      const checked = e.target.checked;
      if (checked) {
        field.pushValue(propertyKey);
      } else {
        field.removeValue(fieldIndex);
      }
    },
    [field, fieldIndex, propertyKey],
  );

  return (
    <Checkbox
      name={field.name}
      checked={fieldIndex > -1}
      onChange={onChange}
      onBlur={field.handleBlur}
      disabled={disabled}
      testId={testId}
    />
  );
};

export default RuleCheckbox;
